<template>
  <v-dialog
    v-model="deleteDialog"
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">
        <p>{{ $t('Workspace.setting.message') }}</p>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="blue-grey lighten-2"
          dark
          depressed
          @click="closeDiagram()"
        >
          {{ $t('Workspace.setting.noButton') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          color="red"
          dark
          depressed
          @click="deleteDiagram()"
        >
          {{ $t('Workspace.setting.yesButton') }}
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import db from '@/mixins/db'

export default {
  mixins: [db],
  props: ['sheet', 'deleteDialog'],
  data () {
    return {}
  },
  methods: {
    closeDiagram () {
      this.$emit('close-diagram')
    },
    // -------- DB利用 --------
    deleteDiagram () {
      this.openDb(() => {
        const store = this.startTransaction('readwrite')
        const req = store.delete(this.sheet.no)
        req.onsuccess = (e) => {
        }
        req.onerror = (e) => {
          alert('[deleteDiagram openDb Error] Sorry, application error.')
          return false
        }
      })

      this.$router.push('/list')
      return false
    }
    // -------- /DB利用 --------
  }
}
</script>
